import { render } from "./ClinicConsentTemplateEdit.vue?vue&type=template&id=5ec2d765&scoped=true"
import script from "./ClinicConsentTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ClinicConsentTemplateEdit.vue?vue&type=script&lang=js"

import "./ClinicConsentTemplateEdit.vue?vue&type=style&index=0&id=5ec2d765&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec2d765"]])

export default __exports__